import { isNil, get } from 'lodash';

/**
 * Gets the map server element id.
 *
 * @param {object} mapServerElementObject - The map server element object.
 * @returns {string} The id for the map server element or empty string if not found.
 * @throws {Error} If map server element is null or undefined.
 */
export const getId = mapServerElementObject => {
  if (isNil(mapServerElementObject)) {
    throw new Error('layer server not defined');
  }
  return get(mapServerElementObject, '_id', '');
};

/**
 * Get map server element name.
 *
 * @param {object} mapServerElementObject - The map server element object.
 * @returns {string} The name of the map server element or empty string if not found.
 * @throws {Error} If map server element is null or undefined.
 */
export const getName = mapServerElementObject => {
  if (isNil(mapServerElementObject)) {
    throw new Error('layer server not defined');
  }
  return get(mapServerElementObject, 'name', '');
};

/**
 * Gets the map server element type.
 *
 * @param {object} mapServerElementObject - The map server element object.
 * @returns {string} The map server element type or empty string if not found.
 * @throws {Error} If map server element is null or undefined.
 */
export const getType = mapServerElementObject => {
  if (isNil(mapServerElementObject)) {
    throw new Error('layer server not defined');
  }
  return get(mapServerElementObject, 'type', '');
};

/**
 * Gets the map server element's source Id.
 *
 * @param {object} mapServerElementObject - The map server element object.
 * @returns {string} The map server element's source Id or empty string if not found.
 * @throws {Error} If map server element is null or undefined.
 */
export const getSourceId = mapServerElementObject => {
  if (isNil(mapServerElementObject)) {
    throw new Error('layer server not defined');
  }
  return get(mapServerElementObject, 'sourceId', '');
};

/**
 * Gets the map server element map server url.
 *
 * @param {object} mapServerElementObject - The map server element object.
 * @returns {string} The map server element map server url or empty string if not found.
 * @throws {Error} If map server element is null or undefined.
 */
export const getMapServerUrl = mapServerElementObject => {
  if (isNil(mapServerElementObject)) {
    throw new Error('layer server not defined');
  }
  return get(mapServerElementObject, 'url', '');
};

/**
 * Checks if the  map server element is deleted.
 *
 * @param {object} mapServerElementObject - The  map server element object.
 * @returns {boolean} True if the  map server element is in trash, false otherwise.
 * @throws {Error} If  map server element is null or undefined.
 */
export const isDeleted = mapServerElementObject => {
  if (isNil(mapServerElementObject)) {
    throw new Error('layer server not defined');
  }
  return get(mapServerElementObject, 'deleted', '') !== 'no';
};
